import { Quote } from "lucide-react";

const TESTIMONIALS = [
  { name: "Amina Hassan", role: "CEO, AgriGrow TZ", text: "Tanz-Bridge connected our produce to international buyers. Revenue doubled within a year." },
  { name: "David Mwangi", role: "Director, Nexus IT", text: "Their IT consultancy modernized our whole infrastructure. Truly a commitment for excellence." },
  { name: "Grace Kimaro", role: "Founder, EcoLeaf", text: "The environmental audit helped us cut our carbon footprint by 40%. Highly professional team." },
];

export const TestimonialsSection = () => {
  return (
    <section className="bg-brand-dark py-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <h2 className="text-3xl font-heading font-extrabold tracking-tight mb-12 text-center text-white">Trusted across the region</h2>
        <div className="grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t) => (
            <div key={t.name} data-testid={`testimonial-${t.name.split(" ")[0].toLowerCase()}`}
              className="rounded-lg bg-white/5 border border-white/10 p-8">
              <Quote size={28} className="text-brand-yellow mb-4" />
              <p className="text-base font-medium text-gray-100 leading-relaxed mb-6">"{t.text}"</p>
              <p className="font-heading text-white">{t.name}</p>
              <p className="text-sm font-medium text-gray-300">{t.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
